<template>
  <div class="card maxCaptl">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col blue">
              <h3><i class="fas fa-gavel"></i>Bid Validity</h3>
            </div>
            
        </div>
      </div>
      <div class="input-group mb-3">
      <small>Current Bid Validity: <b>{{bidValidity}} Days</b></small>

      </div>
  </div>
</template>
<script>
export default {
  name: "setbidvalidity",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.bidValidity = this.bidSettings.bidValidity;
      },
      deep: true
    }
  },
  data() {
    return {
      bidValidity : "",
      
    };
  },
  methods: {
  },
  
  
};
</script>